<template>
    <div class="ini-description">
        <avatar :record="contact_id.value"></avatar>
        <div class="ini-description__content">
            <div class="ini-description__header">
                <span class="ini-description__title">{{ $t('LBL_HELPDESK_DESCRIPTION_TITLE') }}</span>
                <span class="ini-description__datetime">{{ transformCreatedTime }}</span>
            </div>
            <div class="ini-description__body">
                <p v-html="description.displayValue"></p>
            </div>
            <div class="ini-commentitem__attachments" v-if="attachments.length > 0">
                <span>{{ $t('LBL_ATTACHED_FILES') }}</span>
                <ini-attachment v-for="(attachment, index) in attachments" v-bind="attachment" @click="attachmentClicked(attachment)"/>
            </div>
        </div>
    </div>
</template>

<script>

    import Avatar from "@/components/Avatar"
    import IniAttachment from '@/components/Attachment'
    import AppMixin from "@/mixins/AppMixin";

    export default {
        components: {
            Avatar,
            IniAttachment
        },
        mixins: [AppMixin],
        props: {
            description: {
                type: Object,
                default: ()=> ({value: '', displayValue: ''})
            },
            createdtime: {
                type: Object,
                default: ()=> ({value: '', displayValue: ''})
            },
            contact_id: null,
            attachments: {
                type: Array,
                default: () => []
            }
        },

        computed: {
            transformCreatedTime() {
                return this.getLocaltime(this.createdtime.value)
            }
        },

        methods: {
            attachmentClicked(attachment) {
                this.$emit('attachment-clicked', attachment)
            },
        }
    }
</script>
<style lang="scss">@import "@/assets/scss/components/HelpDesk/Detail/_description.scss";</style>